import { type AreasV2, MeasurementSystem, getEntries } from '@pkgs/api';

/**
 * Example:
 * {
 *  totalSurface: 100,
 *  totalSurface: 10.
 * }
 *  => { totalSurface_SQFT: 100, totalSurface_SQMT: 10 }
 */
export function appendSuffixToKeys(areas: AreasV2, measurementSystem: MeasurementSystem): Record<string, number> {
  const suffix = measurementSystem === MeasurementSystem.metric ? 'SQMT' : 'SQFT';
  const areaEntries = getEntries(areas);
  return areaEntries.reduce((acc, [key, value]) => {
    return {
      ...acc,
      [`${key}_${suffix}`]: value,
    };
  }, {});
}
